import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import ExampleTable from '../views/ExampleTable.vue'
import ReportPage from '../views/ReportPage.vue'
import LoginPage from '../views/LoginPage.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/login', component: LoginPage, name: 'LoginPage' },
  { path: '/home', component: HomePage, name: 'HomePage' },
  { path: '/table', component: ExampleTable, name: 'ExampleTable' },
  { path: '/report', component: ReportPage, name: 'ReportPage' },

  // 系统管理相关路由
  {
    path: "/system/admin",
    name: "账号管理",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/users/index.vue")
  },
  {
    path: "/system/menu",
    name: "菜单管理",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/menu/index.vue")
  },
  {
    path: "/system/permission",
    name: "权限管理",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/permission/index.vue")
  },
  {
    path: "/system/role",
    name: "角色管理",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/role/index.vue")
  },
  {
    path: "/system/tag",
    name: "标签管理",
    component: () => import(/* webpackChunkName: "about" */ "@/views/system/tag/index.vue")
  },
  
  // 公司介绍相关路由
  {
    path: "/website/infomation",
    name: "公司信息",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/index.vue")
  },
  {
    path: "/website/company-settings",
    name: "企业基础设置",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/companySettings.vue")
  },
  {
    path: "/website/advantages",
    name: "我们的优势",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/advantages.vue")
  },
  {
    path: "/website/awards",
    name: "荣誉资质",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/awards.vue")
  },
  {
    path: "/website/process",
    name: "发展历程",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/milestone.vue")
  },
  {
    path: "/website/culture",
    name: "企业文化",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/culture.vue")
  },
  {
    path: "/website/product_categories",
    name: "产品分类",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/productCategory.vue")
  },
  {
    path: "/website/news_categories",
    name: "动态分类",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/newsCategory.vue")
  },
  {
    path: "/website/news",
    name: "动态列表",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/dynamic.vue")
  },
  {
    path: "/website/products",
    name: "产品列表",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/product.vue")
  },
  {
    path: "/website/solutions",
    name: "解决方案",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/solutions.vue")
  },
  {
    path: "/website/services",
    name: "制造服务",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/services.vue")
  },
  {
    path: "/website/quality-guarantees",
    name: "质量保障",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/quality-guarantees.vue")
  },
  {
    path: "/website/downloads",
    name: "下载中心",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/downloads.vue")
  },
  {
    path: "/website/banners",
    name: "Banner 管理",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/banners.vue")
  },
  {
    path: "/website/contact-categories",
    name: "联系分类",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/contactCategories.vue")
  },
  {
    path: "/website/contact-submissions",
    name: "联系记录",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/contactSubmissions.vue")
  },
  {
    path: "/website/visit",
    name: "访问记录",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/visitLogs.vue")
  },
  {
    path: "/website/seo",
    name: "SEO设置",
    component: () => import(/* webpackChunkName: "about" */ "@/views/website/seoSettings.vue")
  },

  // 任务看板相关路由
  {
    path: "/task/projects",
    name: "项目管理",
    component: () => import(/* webpackChunkName: "about" */ "@/views/task/projects.vue")
  },
  {
    path: "/task/boards",
    name: "任务看板",
    component: () => import(/* webpackChunkName: "about" */ "@/views/task/boards.vue")
  },
  {
    path: "/mine",
    name: "个人中心",
    component: () => import(/* webpackChunkName: "about" */ "@/views/mine/index.vue")
  },
  {
    path: "/mine/password",
    name: "修改密码",
    component: () => import(/* webpackChunkName: "about" */ "@/views/mine/password.vue")
  }
]

const router = new VueRouter({
  routes
})

export default router
